<template>
	<div class="tp">
		<div class="top-menu" :class="coachEffectClass">
			<div class="top-menu-left">
				<div class="top-menu-left-avatar" @click="toggleSideProfile()" v-if="endUser && hasGamification">
					<div class="top-menu-left-avatar-active" v-if="activeChallenges || $store.state.remindChallenge">
						{{ activeChallenges || $store.state.remindChallenge }}
					</div>

					<img v-if="customProfileIcon" :src="$imgUrl(customProfileIcon)"
						:width="endUser.first_name ? 27 : 40">
					<img v-if="!customProfileIcon" src="@/assets/img/medal-challenge.png"
						:width="endUser.first_name ? 27 : 40">
					{{ endUser.first_name }}
				</div>

				<div class="top-menu-left-client" :class="{ noGamification: !hasGamification }" v-if="client.logo">
					<img :src="$imgUrl(client.logo)">
				</div>
			</div>

			<div class="top-menu-middle"
				:class="{ hidden: !$store.state.filterOpen || ($store.state.coachOpen && $store.state.coachEffect !== 'highlight_bike_layer') }"
				ref="middle">
				<span class="top-menu-middle-toggle" @click="toggleHidden()">
					<span class="top-menu-middle-toggle-rect"></span>
					<span class="top-menu-middle-toggle-rect"></span>
				</span>

				<span class="top-menu-middle-filter-text" v-if="!client.no_map" v-html="__('top_filter_text')"></span>

				<span v-for="layer in layers" :key="layer.id" :class="{ 'active': layer.active }"
					:style="{ 'background-color': applyActiveColor(layer), 'border-color': applyActiveColor(layer) }"
					class="top-menu-middle-btn" @click="toggleLayer(layer)">
					<i v-if="layer.icon_font" :class="layer.icon_font"></i>

					<v-img v-if="layer.icon && !layer.icon_font" :src="$imgUrl(layer.icon)" height="20px" />

					{{ layer.__title }}
				</span>

				<Banners :bottom="true" />
			</div>

			<div class="top-menu-right" v-if="!$store.state.client.no_map" @click="toggleSideMenu()">
				<div class="top-menu-right-find">
					<img src="@/assets/img/find.png" width="27">
					<span v-html="__('top_menu_find')"></span>
				</div>
			</div>
		</div>

		<LanguagePicker />

		<Banners :top="true" />
	</div>
</template>

<script>
import { debounce } from 'debounce'
import moment from 'moment'
import Banners from '@/components/Banners'
import LanguagePicker from '@/components/LanguagePicker.vue';

export default {
	name: 'TopMenu',
	components: { Banners, LanguagePicker },

	data() {
		return {
			bannerClosed: false
		}
	},

	mounted() {
		window.onresize = debounce((evt) => {
			this.$store.state.filterHeight = this.$refs.middle?.clientHeight || null
		}, 200)

		this.$store.state.filterHeight = this.$refs.middle?.clientHeight || null

		// If there's no interaction with quiz or challenge within X minutes, remind by putting an ! beside the avatar
		if (this.hasGamificationInteraction || !this.endUser) {
			return
		}

		let diffSinceFirst = Math.abs(moment(this.$store.state.endUser.firstLogin).diff(moment(), 'minutes'))
		let minUntilTimeout = diffSinceFirst < 5 ? 5 - diffSinceFirst : 0

		setTimeout(() => {
			if (!this.hasGamificationInteraction) {
				this.$store.state.remindChallenge = '!'
			}
		}, 1000 * 60 * minUntilTimeout)
	},

	methods: {
		toggleHidden() {
			this.$store.state.filterOpen = !this.$store.state.filterOpen

			if (!this.hidden) {
				this.$metric({ 'event': 'coach_interaction', 'InteractionLocation': 'menu', 'InteractionType': 'opened' })
			}
		},

		toggleLayer(layer) {
			layer.active = !layer.active

			layer.point_categories = layer.point_categories.map(c => ({ ...c, active: layer.active }))

			this.$metric({ 'event': 'layer_interaction', 'InteractionType': layer.active ? 'activate' : 'deactivate', 'LayerType': layer.title, 'InteractionLocation': 'top-menu' })

			this.$nextTick(() => this.$store.state.filterHeight = this.$refs.middle.clientHeight)

			this.$nextTick(() => {
				if (this.$store.state.markerClusterer) {
					this.$store.state.markerClusterer.clearMarkers()
					this.$store.state.markerClusterer.addMarkers(this.$store.state.markers)
				}
			})

			// Update cluster (because of changed markers)
		},

		applyActiveColor(layer) {
			if (layer.active && layer.icon_font_color) {
				return layer.icon_font_color + ' !important'
			}
		},

		toggleSideMenu() {
			this.$store.state.sideMenuOpen = !this.$store.state.sideMenuOpen
		},

		toggleSideProfile() {
			this.$store.state.sideProfileOpen = !this.$store.state.sideProfileOpen
		},

		setLanguage(lang) {
			this.$changeLang(lang)
		},
	},

	computed: {
		coachEffectClass() {
			return this.$store.state.coachEffect
		},

		layers() {
			return this.$store.getters.translatedLayers
				.filter(l => l.show_in_menu && !l.hidden)
		},

		endUser() {
			return this.$store.state.endUser
		},

		customProfileIcon() {
			return this.$store.state.client?.custom_profile
		},

		client() {
			return this.$store.state.client
		},

		hasGamification() {
			return this.$store.getters.cards
				.filter(c => (c.type === 'challenge' || c.type === 'quiz') && !c.hidden)
				.length > 0
		},

		challenges() {
			return this.$store.getters.cards
				.filter(c => c.type === 'challenge')
		},

		hasGamificationInteraction() {
			return this.$store.getters.cards
				.filter(c => c.type === 'challenge' || c.type === 'quiz')
				.filter(c => c.accepted || c.finished)
				.length !== 0
		},

		activeChallenges() {
			return this.challenges
				.filter(c => c.accepted)
				.length
		},
	}
}
</script>
